import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
// import VueRouter from "vue-router";
import App from "./App";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import router from "./routes";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import store from "./store";
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import Widgets from "fusioncharts/fusioncharts.widgets";
import PowerCharts from "fusioncharts/fusioncharts.powercharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import VueFusionCharts from "vue-fusioncharts";
import { IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import 'core-js'

// router setup
import routes from "./routes";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";
import * as VueGoogleMaps from "vue2-google-maps";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vuetify from "./plugins/vuetify";
// import Vuesax from "./plugins/Vuesax";
import VueSkycons from "vue-skycon";
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css'
// import ArgonDashboard from './plugins/argon-dashboard'

import { Tabs, Tab } from "vue-tabs-component";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyChmM8jDn3mIpFEK5caePyw3IAci5-mU1o",
    region:"MA"
  },
});
// configure router
// const router = new VueRouter({
//   routes, // short for routes: routes
//   linkExactActiveClass: "nav-item active"
// });
// Vue.use(ArgonDashboard)
Vue.use(Vuesax)
Vue.component("tabs", Tabs);
Vue.component("tab", Tab);
Vue.use(CoreuiVue);
Vue.use(IconsPlugin);
Vue.prototype.$Chartist = Chartist;
Vue.use(VueSkycons);
Vue.use(VueFormWizard);
Vue.use(VueMaterial);

// Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);
Charts(FusionCharts);
PowerCharts(FusionCharts);
Widgets(FusionCharts);
FusionTheme(FusionCharts);
Vue.use(VueFusionCharts, FusionCharts);
/* eslint-disable no-new */
new Vue({
  // el: "#app",
  router,
  vuetify,
  store,
  icons,
  data: {
    Chartist: Chartist,
  },
  render: (h) => h(App),
}).$mount("#app");


